export default __webpack_public_path__ + "static/media/7.6631aa8f.gif";